import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
} from "react-bootstrap";
import {
  FaLaptopCode,
  FaChalkboardTeacher,
  FaBuilding,
  FaBriefcase,
  FaArrowRight,
  FaCheckCircle,
  FaUsers,
  FaStar,
  FaClock,
  FaCertificate,
  FaLaptop,
  FaHandshake,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PublicNavbar from "../../components/public/Navbar";
import Footer from "../../components/public/Footer";
import "../../styles/services.css";

const Services = () => {
  const navigate = useNavigate();
  const [showInquiryModal, setShowInquiryModal] = useState(false);
  const [inquiryForm, setInquiryForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleInquirySubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setShowInquiryModal(false);
      setSubmitted(false);
      setInquiryForm({ name: "", email: "", phone: "", message: "" });
    }, 2000);
  };

  const trainingPrograms = [
    {
      icon: FaLaptopCode,
      title: "App Development",
      description: "MIT App Inventor, Android, Flutter",
      duration: "3 months",
      price: "₹15,000",
    },
    {
      icon: FaLaptop,
      title: "Web Development",
      description: "HTML, CSS, JavaScript, React",
      duration: "4 months",
      price: "₹18,000",
    },
    {
      icon: FaLaptopCode,
      title: "Data Science",
      description: "Python, SQL, Machine Learning",
      duration: "5 months",
      price: "₹25,000",
    },
    {
      icon: FaLaptop,
      title: "Digital Marketing",
      description: "SEO, Social Media, Google Ads",
      duration: "3 months",
      price: "₹12,000",
    },
  ];

  const stats = [
    { number: "500+", label: "Students Placed", icon: FaUsers },
    { number: "21+", label: "Years Experience", icon: FaClock },
    { number: "95%", label: "Success Rate", icon: FaStar },
    { number: "50+", label: "Partner Companies", icon: FaBuilding },
  ];

  const whyChoose = [
    {
      icon: FaChalkboardTeacher,
      title: "Expert Trainers",
      description:
        "Learn from industry professionals with 10+ years experience",
    },
    {
      icon: FaCertificate,
      title: "Industry Certificate",
      description: "Get recognized certificates upon completion",
    },
    {
      icon: FaClock,
      title: "Flexible Schedule",
      description: "Weekday, weekend & online batches available",
    },
    {
      icon: FaHandshake,
      title: "Placement Support",
      description: "Resume building, mock interviews & job referrals",
    },
  ];

  return (
    <div className="services-page-wrapper">
      <PublicNavbar />
      <div className="services-page-nav-spacer"></div>

      {/* Hero Section */}
      <section className="services-page-hero">
        <div className="services-page-hero-bubbles">
          <div className="services-page-bubble"></div>
          <div className="services-page-bubble"></div>
          <div className="services-page-bubble"></div>
          <div className="services-page-bubble"></div>
          <div className="services-page-bubble"></div>
        </div>
        <Container>
          <div className="services-page-hero-content text-center">
            <div className="services-page-hero-badge">
              <span>🚀</span>
              <span>Your Trusted IT Training Partner</span>
              <span>✨</span>
            </div>
            <h1 className="services-page-hero-title">
              Our <span className="services-page-highlight">Services</span>
            </h1>
            <p className="services-page-hero-subtitle">
              Comprehensive IT training solutions for students, professionals,
              and businesses
            </p>
          </div>
        </Container>
        <div className="services-page-hero-wave">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"
            ></path>
          </svg>
        </div>
      </section>

      {/* Stats Section */}
      <Container className="services-page-stats">
        <Row className="g-4">
          {stats.map((stat, index) => (
            <Col md={3} sm={6} key={index}>
              <div className="services-page-stat-card">
                <stat.icon className="services-page-stat-icon" />
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Training Programs */}
      <Container className="services-page-container">
        <div className="services-page-section">
          <div className="services-page-section-header text-center">
            <h2>
              IT Training{" "}
              <span className="services-page-highlight">Programs</span>
            </h2>
            <p>Industry-relevant courses designed to make you job-ready</p>
          </div>
          <Row className="g-4">
            {trainingPrograms.map((program, index) => (
              <Col md={6} lg={3} key={index}>
                <div className="services-page-program-card">
                  <div className="services-page-program-icon">
                    <program.icon />
                  </div>
                  <h3>{program.title}</h3>
                  <p>{program.description}</p>
                  <div className="services-page-program-meta">
                    <span>📅 {program.duration}</span>
                    <span>💰 {program.price}</span>
                  </div>
                  <button
                    className="services-page-program-btn"
                    onClick={() => navigate("/courses")}
                  >
                    Learn More <FaArrowRight className="ms-2" />
                  </button>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        {/* Learning Paths */}
        <div className="services-page-section services-page-learning-bg">
          <div className="services-page-section-header text-center">
            <h2>
              Choose Your{" "}
              <span className="services-page-highlight">Learning Path</span>
            </h2>
            <p>Flexible options to fit your schedule and learning style</p>
          </div>
          <Row className="g-4">
            <Col md={4}>
              <div className="services-page-learning-card">
                <div className="services-page-learning-card-inner">
                  <div className="services-page-learning-icon">🏫</div>
                  <h3>Classroom Training</h3>
                  <p>
                    Learn in-person at our state-of-the-art facility in Bhilai
                  </p>
                  <ul>
                    <li>
                      <FaCheckCircle /> Expert instructors
                    </li>
                    <li>
                      <FaCheckCircle /> Lab facilities
                    </li>
                    <li>
                      <FaCheckCircle /> Peer networking
                    </li>
                    <li>
                      <FaCheckCircle /> Batch system
                    </li>
                  </ul>
                  <div className="services-page-learning-btn-wrapper">
                    <button
                      className="services-page-learning-btn"
                      onClick={() => navigate("/courses")}
                    >
                      View Batches
                    </button>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div className="services-page-learning-card">
                <div className="services-page-learning-card-inner">
                  <div className="services-page-learning-icon">💻</div>
                  <h3>Online Self-Paced</h3>
                  <p>Learn anytime, anywhere with lifetime access</p>
                  <ul>
                    <li>
                      <FaCheckCircle /> Video lectures
                    </li>
                    <li>
                      <FaCheckCircle /> Downloadable resources
                    </li>
                    <li>
                      <FaCheckCircle /> 24/7 support
                    </li>
                    <li>
                      <FaCheckCircle /> Certificate on completion
                    </li>
                  </ul>
                  <div className="services-page-learning-btn-wrapper">
                    <button
                      className="services-page-learning-btn"
                      onClick={() => navigate("/courses")}
                    >
                      Browse Courses
                    </button>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div className="services-page-learning-card">
                <div className="services-page-learning-card-inner">
                  <div className="services-page-learning-icon">🎓</div>
                  <h3>Hybrid Learning</h3>
                  <p>Best of both worlds - classroom + online access</p>
                  <ul>
                    <li>
                      <FaCheckCircle /> Live classes + recordings
                    </li>
                    <li>
                      <FaCheckCircle /> Online study materials
                    </li>
                    <li>
                      <FaCheckCircle /> Doubt clearing sessions
                    </li>
                    <li>
                      <FaCheckCircle /> Project guidance
                    </li>
                  </ul>
                  <div className="services-page-learning-btn-wrapper">
                    <button
                      className="services-page-learning-btn"
                      onClick={() => navigate("/contact")}
                    >
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        {/* Corporate Training */}
        <div className="services-page-corporate-section">
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="services-page-corporate-content">
                <div className="services-page-corporate-badge">
                  🏢 For Businesses
                </div>
                <h2>Corporate Training</h2>
                <p className="services-page-corporate-desc">
                  Upskill your team with custom IT training programs
                </p>
                <ul>
                  <li>
                    <FaCheckCircle /> Custom curriculum design
                  </li>
                  <li>
                    <FaCheckCircle /> On-site / off-site delivery
                  </li>
                  <li>
                    <FaCheckCircle /> Flexible scheduling
                  </li>
                  <li>
                    <FaCheckCircle /> Progress tracking & assessment
                  </li>
                  <li>
                    <FaCheckCircle /> ROI-focused training
                  </li>
                </ul>
                <button
                  className="services-page-corporate-btn"
                  onClick={() => setShowInquiryModal(true)}
                >
                  Request a Quote <FaArrowRight className="ms-2" />
                </button>
              </div>
            </Col>
            <Col lg={6}>
              <div className="services-page-corporate-image">
                <FaBuilding
                  size={120}
                  className="services-page-corporate-icon"
                />
              </div>
            </Col>
          </Row>
        </div>

        {/* Placement Assistance */}
        <div className="services-page-placement-section">
          <Row className="align-items-center flex-row-reverse">
            <Col lg={6}>
              <div className="services-page-placement-content">
                <div className="services-page-placement-badge">
                  🎯 Career Support
                </div>
                <h2>Placement Assistance</h2>
                <p className="services-page-placement-desc">
                  Your career partner - Get hired in top companies
                </p>
                <ul>
                  <li>
                    <FaCheckCircle /> Resume building workshops
                  </li>
                  <li>
                    <FaCheckCircle /> Mock interviews
                  </li>
                  <li>
                    <FaCheckCircle /> Technical assessments
                  </li>
                  <li>
                    <FaCheckCircle /> Company referrals
                  </li>
                  <li>
                    <FaCheckCircle /> Job alerts & notifications
                  </li>
                </ul>
                <button
                  className="services-page-placement-btn"
                  onClick={() => navigate("/contact")}
                >
                  Get Placement Support <FaArrowRight className="ms-2" />
                </button>
              </div>
            </Col>
            <Col lg={6}>
              <div className="services-page-placement-image">
                <FaBriefcase
                  size={120}
                  className="services-page-placement-icon"
                />
              </div>
            </Col>
          </Row>
        </div>

        {/* Why Choose Us */}
        <div className="services-page-why-section">
          <div className="services-page-section-header text-center">
            <h2>
              Why Choose{" "}
              <span className="services-page-highlight">Sensible Academy</span>?
            </h2>
            <p>What makes us the preferred choice for IT training</p>
          </div>
          <Row className="g-4">
            {whyChoose.map((item, index) => (
              <Col md={3} sm={6} key={index}>
                <div className="services-page-why-card">
                  <div className="services-page-why-icon">
                    <item.icon />
                  </div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        {/* CTA Section */}
        <div className="services-page-cta">
          <div className="services-page-cta-content text-center">
            <div className="services-page-cta-icon">🚀</div>
            <h2>Ready to Start Your Learning Journey?</h2>
            <p>
              Join thousands of successful students who transformed their
              careers with us
            </p>
            <div className="services-page-cta-buttons">
              <button
                className="services-page-cta-primary"
                onClick={() => navigate("/register")}
              >
                Enroll Now
              </button>
              <button
                className="services-page-cta-secondary"
                onClick={() => navigate("/contact")}
              >
                Talk to Counselor
              </button>
            </div>
          </div>
        </div>
      </Container>

      {/* Inquiry Modal */}
      <Modal
        show={showInquiryModal}
        onHide={() => setShowInquiryModal(false)}
        centered
        className="services-page-inquiry-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Corporate Training Inquiry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {submitted ? (
            <div className="services-page-modal-success text-center py-4">
              <FaCheckCircle size={60} className="text-success mb-3" />
              <h4>Thank You!</h4>
              <p>We'll get back to you within 24 hours.</p>
            </div>
          ) : (
            <Form onSubmit={handleInquirySubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Company Name *</Form.Label>
                <Form.Control
                  type="text"
                  required
                  placeholder="Enter company name"
                  value={inquiryForm.name}
                  onChange={(e) =>
                    setInquiryForm({ ...inquiryForm, name: e.target.value })
                  }
                  className="services-page-form-control"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email Address *</Form.Label>
                <Form.Control
                  type="email"
                  required
                  placeholder="Enter email address"
                  value={inquiryForm.email}
                  onChange={(e) =>
                    setInquiryForm({ ...inquiryForm, email: e.target.value })
                  }
                  className="services-page-form-control"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number *</Form.Label>
                <Form.Control
                  type="tel"
                  required
                  placeholder="Enter phone number"
                  value={inquiryForm.phone}
                  onChange={(e) =>
                    setInquiryForm({ ...inquiryForm, phone: e.target.value })
                  }
                  className="services-page-form-control"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Training Requirements</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Tell us about your training needs..."
                  value={inquiryForm.message}
                  onChange={(e) =>
                    setInquiryForm({ ...inquiryForm, message: e.target.value })
                  }
                  className="services-page-form-control"
                />
              </Form.Group>
              <button type="submit" className="services-page-submit-btn w-100">
                Submit Inquiry
              </button>
            </Form>
          )}
        </Modal.Body>
      </Modal>

      <Footer />
    </div>
  );
};

export default Services;
